import React, { useContext } from "react";
import { get } from "lodash";

import Slider from "src/components/slider";
import Button from "src/components/button";

import { DealRoomActionPlanContext } from "../context";
import { getCascadeDateDayDifference } from "src/utils/dealRoom.helper";

import styles from "./styles.module.scss";

interface CascadeDatesSliderProps {
  show: boolean;
  handleClose: () => void;
  handleFinish: () => void | Promise<void>;
}

const CascadeDatesSlider: React.FC<CascadeDatesSliderProps> = ({
  show,
  handleClose,
  handleFinish,
}) => {
  const { state } = useContext(DealRoomActionPlanContext);

  const cascadingActionItem = get(state, "cascadingActionItem");
  const updatedDate = get(cascadingActionItem, "updatedDate");
  const previousDueDate = get(cascadingActionItem, "targetAction.dueDate");
  const subsequentActionsCount = get(
    cascadingActionItem,
    "subsequentActionsCount",
    0,
  );
  const loading = get(cascadingActionItem, "cascadeDates.loading", false);

  const dayDifference =
    updatedDate && previousDueDate
      ? getCascadeDateDayDifference(updatedDate, previousDueDate)
      : 0;
  const absDays = Math.abs(dayDifference);
  const dayWord = absDays === 1 ? "day" : "days";
  const itemWord = subsequentActionsCount === 1 ? "item" : "items";
  const direction = dayDifference >= 0 ? "forward" : "backward";

  const handleConfirmClick = () => {
    handleFinish();
  };

  return (
    <Slider.Dialog width="400" show={show} onClose={handleClose}>
      <Slider.Header>
        <div className={styles.headerContainer}>
          <p className={styles.header}>shift dates?</p>
          <p className={styles.subtext}>
            Shift <span className={styles.highlight}>&quot;{subsequentActionsCount}&quot;</span> subsequent {itemWord}{" "}
            {direction} by <span className={styles.highlight}>&quot;{absDays} {dayWord}&quot;</span> to match the updated timeline?
          </p>
        </div>
      </Slider.Header>

      <Slider.Body></Slider.Body>

      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          text={loading ? "Confirming" : "Confirm"}
          variant="primary"
          onClick={handleConfirmClick}
          disabled={loading}
        />
        <Button text="Cancel" variant="secondary" onClick={handleClose} />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default CascadeDatesSlider;
